import _defer from "./defer";
import _empty from "./empty";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var defer_1 = _defer;
var empty_1 = _empty;

function iif(condition, trueResult, falseResult) {
  if (trueResult === void 0) {
    trueResult = empty_1.EMPTY;
  }

  if (falseResult === void 0) {
    falseResult = empty_1.EMPTY;
  }

  return defer_1.defer(function () {
    return condition() ? trueResult : falseResult;
  });
}

exports.iif = iif; //# sourceMappingURL=iif.js.map

export default exports;